// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { VueAxios } from './utils/request'
import VueClipboard from 'vue-clipboard2'
import vuescroll from 'vuescroll/dist/vuescroll-slide'
import 'vuescroll/dist/vuescroll.css'

Vue.use(vuescroll, {
  ops: {
    scrollPanel: {
      scrollingX: false
    },
    vuescroll: {
      pullRefresh: {
        enable: true,
        tips: {
          deactive: 'Pull to Refresh',
          active: 'Release to Refresh',
          start: 'Refreshing...',
          beforeDeactive: 'Refresh Successfully!'
        }
      },
      pushLoad: {
        enable: true,
        tips: {
          deactive: 'Push to Load',
          active: 'Release to Load',
          start: 'Loading...',
          beforeDeactive: 'Load Successfully!'
        },
        auto: false,
        autoLoadDistance: 0
      }
    },
    bar: {
      background: '#fff'
    }
  }
})
Vue.use(VueClipboard)
Vue.use(VueAxios)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js